export const addCode = (reservation) => ({
	...reservation,
	code: "RV" + String(reservation.id).substr(-3),
});
